import './TrialExpiredModal.css';

type RevertToTrialModalProps = {
  open: boolean;
  daysRemaining: number | null;
  loading?: boolean;
  error?: string | null;
  onConfirm: () => void;
  onCancel: () => void;
};

const RevertToTrialModal = ({
  open,
  daysRemaining,
  loading = false,
  error = null,
  onConfirm,
  onCancel,
}: RevertToTrialModalProps) => {
  if (!open) return null;

  const daysLabel = daysRemaining === 1 ? '1 day' : `${Math.max(daysRemaining ?? 0, 0)} days`;

  return (
    <div className="trial-modal-overlay" role="presentation" onClick={onCancel}>
      <div
        className="trial-modal-content"
        role="dialog"
        aria-modal="true"
        aria-labelledby="revert-to-trial-title"
        onClick={e => e.stopPropagation()}
      >
        <button
          type="button"
          className="trial-modal-close"
          onClick={onCancel}
          aria-label="Close"
          disabled={loading}
        >
          ×
        </button>

        <div className="trial-modal-icon" style={{ color: 'var(--blue-color, #2563eb)' }}>
          <i className="bi bi-arrow-counterclockwise" aria-hidden="true" />
        </div>

        <h2 id="revert-to-trial-title" className="trial-modal-title">
          Return to trial?
        </h2>

        <p className="trial-modal-message">
          You still have <strong>{daysLabel}</strong> left with full trial access.
        </p>

        <p className="trial-modal-message" style={{ marginTop: '-16px' }}>
          You can do this <strong>only once</strong>. After that, activating your academic plan is final until
          the trial ends.
        </p>

        {error && <p className="trial-modal-error">{error}</p>}

        <div className="trial-modal-actions">
          <button
            type="button"
            className="btn-gradient-blue trial-modal-btn-primary"
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? 'Restoring trial…' : 'Back to trial'}
          </button>
          <button type="button" className="trial-modal-btn-secondary" onClick={onCancel} disabled={loading}>
            Stay on academic
          </button>
        </div>
      </div>
    </div>
  );
};

export default RevertToTrialModal;
